import api from './client';

export interface FABPreferencesResponse {
  actionKeys: string[] | null;
  layout: 'vertical' | 'narrow';
  onboarded: boolean;
}

export interface FABPreferencesPatch {
  actionKeys?: string[] | null;
  layout?: 'vertical' | 'narrow';
  onboarded?: boolean;
}

export const fabPreferencesApi = {
  get: () => api.get<FABPreferencesResponse>('/users/me/fab-preferences'),
  update: (patch: FABPreferencesPatch) => api.put('/users/me/fab-preferences', patch),
};
